import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import GestureOutlinedIcon from '@mui/icons-material/GestureOutlined';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const MapPreviewPanel = ({
  areaMode,
  canUseAreaControls,
  canUseDrawAreaModes,
  contactTypeCopy,
  handleDrawToolSelect,
  handleMapTypeSelect,
  isDrawingShape,
  isDrawRadiusToolActive,
  isFindHomesAroundLocationsMode,
  isFreeformToolActive,
  isManualAreaMode,
  mapAddress,
  mapError,
  mapPreviewRef,
  mapRef,
  mapStatus,
  mapTypeId,
  shouldBlockMapForManualEstimate,
}) => (
  <Box ref={mapPreviewRef} className={isDrawingShape ? 'mapPreview drawingMap' : 'mapPreview'}>
    <Box ref={mapRef} className="googleMapCanvas" />
    {mapStatus === 'ready' && (
      <Box aria-label="Map style" className="compactMapTypeControl">
        <button
          aria-pressed={mapTypeId === 'roadmap'}
          className={mapTypeId === 'roadmap' ? 'selected' : ''}
          onClick={() => handleMapTypeSelect('roadmap')}
          type="button"
        >
          Map
        </button>
        <button
          aria-pressed={mapTypeId === 'satellite'}
          className={mapTypeId === 'satellite' ? 'selected' : ''}
          onClick={() => handleMapTypeSelect('satellite')}
          type="button"
        >
          Satellite
        </button>
      </Box>
    )}
    {mapStatus === 'loading' && (
      <Box className="mapOverlayState">
        <Typography>Loading Google Maps...</Typography>
      </Box>
    )}
    {shouldBlockMapForManualEstimate && (
      <Box className="mapOverlayState radiusSearchState">
        <Typography>Estimating {contactTypeCopy.plural} in the selected area...</Typography>
      </Box>
    )}
    {mapStatus === 'error' && (
      <Box className="mapOverlayState errorState">
        <Typography>{mapError}</Typography>
      </Box>
    )}
    {!mapAddress && !isFindHomesAroundLocationsMode && mapStatus === 'ready' && (
      <Box className="emptyMapState">
        <Typography>
          Add a starting address to preview it on the map.
        </Typography>
      </Box>
    )}
    {(mapAddress || isFindHomesAroundLocationsMode) && mapStatus === 'ready' && canUseDrawAreaModes && isManualAreaMode && (
      <Box className="drawMapToolbar">
        <Box className="drawToolSegment">
          <button
            aria-label="Draw circle"
            aria-pressed={isDrawRadiusToolActive}
            className={isDrawRadiusToolActive ? 'drawToolOption selected' : 'drawToolOption'}
            disabled={!canUseAreaControls}
            onClick={() => handleDrawToolSelect('radius')}
            title="Draw circle"
            type="button"
          >
            <RadioButtonUncheckedIcon />
            Circle
          </button>
          <button
            aria-label="Draw freeform area"
            aria-pressed={isFreeformToolActive}
            className={isFreeformToolActive ? 'drawToolOption selected' : 'drawToolOption'}
            disabled={!canUseAreaControls}
            onClick={() => handleDrawToolSelect('freeform')}
            title="Draw freeform area"
            type="button"
          >
            <GestureOutlinedIcon />
            Freeform
          </button>
        </Box>
      </Box>
    )}
    {isDrawingShape && areaMode === 'draw-radius' && (
      <Box className="drawCircleTooltip" role="tooltip">
        Click and drag to size the circle.
      </Box>
    )}
    {isDrawingShape && areaMode === 'custom' && (
      <Box className="drawCircleTooltip" role="tooltip">
        Click and drag to draw your area.
      </Box>
    )}
  </Box>
);

export default MapPreviewPanel;
